// booking/services/bookingTracking.ts
import trackGA4 from './trackingGa4'

import type { Cart, CartCustomer, Session, TicketQuantities } from '../types/booking'

export function trackMoveStage(stage: number) {
  trackGA4.moveStage(stage)
}

export function trackAddToCart(quantities: TicketQuantities) {
  trackGA4.addToCart(trackGA4.transformLinesToItems({ quantities }))
}

export function trackBeginCheckout(quantities: TicketQuantities, session: Session) {
  trackGA4.beginCheckout(trackGA4.transformLinesToItems({ quantities, session }))
}

export function trackCustomerData(data: CartCustomer) {
  trackGA4.addCustomerData(data)
}

export function trackPaymentInfo(method: string, cart: Cart) {
  // use if you migrate payment finalisation later
  trackGA4.addPaymentInfo(method, trackGA4.transformLinesToItems({ cart }))
}
